import React from "react";
import "../ResultScreen.css";

interface ResultTabsProps {
  activePage: string;
  onPageChange: (page: string) => void;
  isSinglePlayer: boolean;
  showHighScores: boolean;
}

const ResultTabs: React.FC<ResultTabsProps> = ({
  activePage,
  onPageChange,
  isSinglePlayer,
  showHighScores,
}) => {
  return (
    <div className="result-screen-tabs">
      <button
        className={`result-screen-tab ${activePage === "rank" ? "active" : ""}`}
        onClick={() => onPageChange("rank")}
      >
        Rank
      </button>
      <button
        className={`result-screen-tab ${activePage === "speed" ? "active" : ""}`}
        onClick={() => onPageChange("speed")}
      >
        Speed
      </button>
      {isSinglePlayer && showHighScores && (
        <button
          className={`result-screen-tab ${activePage === "highscore" ? "active" : ""}`}
          onClick={() => onPageChange("highscore")}
        >
          High Scores
        </button>
      )}
    </div>
  );
};

export default ResultTabs;

